export default __webpack_public_path__ + "static/media/icon-arrow-button-white.382e42ec.svg";